// extracted by mini-css-extract-plugin
module.exports = {"wizard":"Wizard_wizard_1yYEF","wizardRow":"Wizard_wizardRow_1hyEC"};